import { linkedInFwdLinkIdMapping } from './linkedin/linkedin-fwd-linkId-mapping';

// mapping of  editorial reason code to fwd linkId
export const fwdLinkIdMapping = {
  0: 597017,
  1: 534280,
  2: 534287,
  3: 2303306,
  4: 2207237,
  5: 534512,
  6: 534512,
  7: 534270,
  8: 597017,
  9: 2300216,
  10: 2299926,
  14: 2300041,
  15: 534509,
  16: 2207237,
  17: 2207057,
  18: 2299856,
  19: 2207237,
  20: 534340,
  22: 2300224,
  23: 534481,
  24: 534507,
  25: 534393,
  26: 2300303,
  28: 2299854,
  30: 534280,
  31: 2207237,
  32: 2169175,
  33: 2207237,
  35: 534271,
  36: 597017,
  38: 2206949,
  39: 534523,
  40: 534482,
  41: 2207237,
  42: 534530,
  44: 597017,
  45: 534276,
  46: 2207237,
  47: 534474,
  48: 534280,
  49: 534281,
  50: 534282,
  51: 2205489,
  52: 534273,
  53: 534280,
  54: 534283,
  55: 534525,
  56: 534525,
  59: 2206509,
  62: 534274,
  63: 534284,
  64: 2299855,
  65: 534338,
  66: 2299856,
  67: 2302319,
  85: 2206162,
  88: 534508,
  89: 2206162,
  90: 534515,
  91: 2207237,
  92: 2299860,
  93: 2205489,
  94: 534485,
  95: 534576,
  96: 534577,
  100: 534338,
  101: 2206243,
  102: 534338,
  103: 2206243,
  104: 534338,
  105: 534429,
  106: 534342,
  107: 534341,
  108: 534340,
  109: 534488,
  110: 534343,
  111: 534458,
  112: 2206243,
  113: 534560,
  114: 534561,
  115: 0,
  116: 0,
  117: 534526,
  118: 0,
  119: 534504,
  120: 0,
  121: 534526,
  122: 0,
  123: 597017,
  124: 534338,
  125: 534339,
  128: 2207053,
  129: 534290,
  130: 534291,
  131: 2303306,
  132: 2303306,
  133: 534294,
  134: 534295,
  135: 534296,
  136: 534297,
  137: 534353,
  138: 534354,
  139: 534355,
  140: 534356,
  141: 534433,
  142: 534434,
  143: 2299926,
  144: 534436,
  145: 534437,
  146: 534438,
  147: 534461,
  148: 534462,
  149: 534487,
  150: 2300041,
  151: 534399,
  152: 534504,
  153: 534505,
  154: 534506,
  155: 534526,
  156: 2206243,
  157: 2206243,
  158: 534562,
  159: 534563,
  160: 534564,
  161: 2206243,
  162: 534566,
  163: 2206243,
  164: 2304918,
  165: 534358,
  166: 534359,
  176: 534439,
  177: 534439,
  178: 2299926,
  179: 534442,
  180: 534443,
  182: 534461,
  183: 534464,
  184: 534489,
  198: 534508,
  199: 534338,
  237: 534574,
  238: 534307,
  239: 534308,
  242: 534309,
  243: 534310,
  248: 534338,
  250: 2206350,
  251: 2206350,
  255: 2206509,
  256: 534311,
  257: 534312,
  258: 534313,
  259: 534314,
  260: 534315,
  261: 534365,
  262: 2299855,
  263: 2299926,
  264: 534445,
  265: 2300213,
  266: 2299853,
  267: 2300302,
  268: 534477,
  269: 2300301,
  270: 534516,
  271: 2300041,
  272: 534425,
  273: 2303306,
  274: 2299922,
  275: 2207057,
  276: 2299943,
  277: 2300224,
  278: 2300224,
  279: 534370,
  280: 534371,
  281: 2303306,
  282: 534318,
  283: 534319,
  284: 2299942,
  285: 2207057,
  286: 2207057,
  287: 534569,
  288: 534569,
  289: 534570,
  290: 534571,
  291: 2299857,
  295: 2206505,
  299: 2299398,
  303: 2300041,
  307: 2300041,
  311: 534338,
  315: 2300041,
  319: 2169175,
  323: 2300041,
  327: 534338,
  331: 534338,
  335: 534338,
  339: 2300304,
  340: 534338,
  341: 534338,
  342: 2300146,
  343: 534338,
  344: 534338,
  345: 534338,
  346: 2206243,
  347: 534458,
  348: 534338,
  349: 534508,
  351: 2207237,
  5158: 534338,
  5159: 534338,
  5160: 2299859,
  5161: 534338,
  5162: 534338,
  5163: 2299945,
  5164: 534338,
  5165: 534338,
  5166: 534338,
  5167: 2300041,
  5198: 534338,
  5199: 534338,
  5200: 534338,
  5201: 534338,
  5202: 534338,
  5203: 534338,
  5204: 534338,
  5212: 534338,
  8141: 534338,
  8142: 534338,
  8155: 2207062,
  8159: 2207237,
  8163: 2207230,
  8168: 2206949,
  8174: 2299855,
  8180: 874905,
  8186: 2194432,
  8192: 2194432,
  8198: 2300216,
  8204: 2194432,
  8210: 2194432,
  8216: 2300042,
  8222: 2194528,
  8228: 2206243,
  8234: 2303306,
  8240: 2300224,
  8246: 2299856,
  8252: 2299854,
  8258: 2207057,
  8264: 2299926,
  8270: 2300041,
  8276: 2300041,
  8292: 2300041,
  8298: 2299925,
  8304: 2300041,
  8310: 2300041,
  8316: 2206243,
  8322: 2300030,
  8328: 2300030,
  8334: 2207230,
  8340: 2300146,
  8346: 2300146,
  8352: 534338,
  8358: 2300305,
  8364: 2300042,
  8370: 534502,
  8376: 2300041,
  8382: 2300041,
  8388: 2300041,
  8394: 2300041,
  8400: 2299926,
  8406: 2300216,
  8412: 2300216,
  8418: 2299926,
  8424: 2299942,
  8430: 2300144,
  8436: 2300041,
  8447: 2206243,
  8453: 2206243,
  8459: 2300303,
  8465: 2300215,
  8471: 2299854,
  8477: 2206243,
  8483: 2206243,
  8489: 2206243,
  8495: 2206243,
  8501: 2206243,
  8507: 2206243,
  8513: 2206243,
  8519: 2206243,
  8525: 2299856,
  8531: 2303306,
  8537: 2300224,
  8543: 2299926,
  8549: 2300215,
  8555: 2300041,
  8561: 2299854,
  8567: 2300303,
  8573: 2300303,
  8579: 2300030,
  8585: 2300041,
  8591: 2299926,
  8597: 2299926,
  8603: 2299926,
  8609: 2300041,
  8615: 2299923,
  8627: 2300215,
  8633: 2300215,
  8645: 2300048,
  8651: 2194519,
  8657: 2206437,
  8663: 2299861,
  8669: 2194521,
  8675: 2300041,
  8681: 2300041,
  8687: 2300224,
  8693: 2300224,
  8699: 2300041,
  8705: 2300041,
  8711: 2300041,
  8717: 2300041,
  8729: 2300215,
  8735: 2300041,
  8741: 2300041,
  8747: 2300041,
  8753: 2300041,
  8759: 2300030,
  8771: 2300041,
  8795: 2205489,
  8801: 2205489,
  8825: 534338,
  8855: 2194519,
  8958: 2304918,
  8964: 2304918,
  8970: 2304918,
  8976: 2299861,
  8982: 2304918,
  8988: 2304918,
  8994: 2304918,
  9000: 2304918,
  9006: 2304918,
  9012: 2304918,
  9018: 2300041,
  9024: 2299925,
  9030: 2207057,
  9036: 2299852,
  9042: 2300044,
  9048: 2206949,
  9054: 2207529,
  9060: 2299871,
  9066: 2300047,
  9072: 2206162,
  9078: 2300029,
  9084: 2207237,
  9090: 534338,
  9096: 2305009,
  9102: 2299944,
  9108: 2300224,
  9172: 2304918,
  9178: 2304918,
  9184: 2304918,
  9212: 2308432,
  '10_1': 534438,
  '10_3': 534438,
  '10_7': 534438,
  '10_8': 534438,
  '101_1': 0,
  '102_1': 0,
  '103_1': 0,
  '104_1': 0,
  '105_1': 534438,
  '106_1': 534365,
  '107_1': 534371,
  '108_1': 534354,
  '109_1': 534491,
  '110_1': 534356,
  '111_1': 534462,
  '112_1': 0,
  '113_1': 0,
  '114_1': 0,
  '115_1': 0,
  '116_1': 0,
  '117_1': 534528,
  '118_1': 0,
  '119_1': 534506,
  '120_1': 0,
  '121_1': 0,
  '122_1': 0,
  '123_1': 597017,
  '124_1': 597017,
  '141_2': 534438,
  '142_2': 534438,
  '143_2': 534438,
  '144_2': 534438,
  '145_2': 534438,
  '146_2': 534438,
  '40_1': 534491,
  '40_3': 534491,
  ...linkedInFwdLinkIdMapping,
};

export const LandingUrlMapping = {
  10000: 'https://help.netflix.com/legal/ads-policy',
};
